module.exports = __webpack_public_path__ + "img/3.58117a5b.png";